// App.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Sidebar from "./components/Sidebar/Sidebar";
import Home from "./components/HomePage/HomePage";
// import Employee from "./components/Employee/Employee";
import Header from "./components/Header/Header";
import AddCountry from "./pages/Country/Country";
import CountriesList from "./pages/Country/CountriesList";
import EditCountry from "./pages/Country/EditCountry";
import AddDepartment from "./pages/Department/Department";
import DepartmentList from "./pages/Department/DepartmentList";
import EditDepartment from "./pages/Department/EditDepartment";
import RegionList from "./pages/Region/RegionList";
import RegionForm from "./pages/Region/RegionForm";
import AddRole from "./pages/Role/Role";
import RoleList from "./pages/Role/RoleList";
import EditRole from "./pages/Role/EditRole";
import AddEmployeetype from "./pages/Employeeype/Employeetype";
import EmployeetypeList from "./pages/Employeeype/EmployeetypeList";
import EditEmployeetype from "./pages/Employeeype/EditEmployeetype";
import AddBanktype from "./pages/Banktype/Banktype";
import BanktypeList from "./pages/Banktype/BanktypeList";
import EditBanktype from "./pages/Banktype/EditBanktype";
import AddRegistrationtype from "./pages/Registrationtype/Registrationtype";
import RegistrationtypeList from "./pages/Registrationtype/RegistrationtypeList";
import EditRegistrationtype from "./pages/Registrationtype/EditRegistrationtype";
import District from "./pages/District/District";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute.jsx/ProtectedRoute";
import Unauthorized from "./pages/Unauthorized";
import Settings from "./pages/Settings/Settings";
import EmployeeFormWizard from "./pages/Employee/EmployeePage";
import EmployeeList from "./pages/Employee/EmployeeList";
import UpdateUser from "./pages/users/UpdateUser";
import Register from "./pages/users/Register";
import Login from "./pages/users/Login";
// import EmployeeLists from "./pages/Settings/Employeelists";
import IDCardGenerator from "./pages/Employee/IDCardGenerator";
import Members from "./pages/Members/Members";
import AddCompany from "./pages/Company/Company"
import CompanyList from "./pages/Company/CompanyList"
import EditCompany from "./pages/Company/EditCompany"
import AddProject from "./pages/Projects/Project"
import ProjectList from "./pages/Projects/ProjectList"
import EditProject from "./pages/Projects/EditProject"
import Payments from "./pages/Finance/Payments";
import AddRegistrationfee from "./pages/Regstrationfee/Regstrationfee";
import ViewRegistrationFee from "./pages/Regstrationfee/ViewRegistrationFee";
import EditRegistrationfee from "./pages/Regstrationfee/EditRegistrationfee";


import "./App.css";


// Loading spinner
function LoadingSpinner() {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>Loading...</p>
    </div>
  );
}

// AppContent
function AppContent() {
  const { currentUser, loading } = useAuth();

  if (loading) return <LoadingSpinner />;

  // If not logged in
  if (!currentUser) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // If logged in
  return (
    <div className="app-container">
      <Sidebar />
      <main className="main-content">
        <Header />
        <div className="content-wrapper">
          <Routes>
            <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />

            {/* Role */}
            <Route path="/ViewRole" element={<ProtectedRoute requiredRole={["developer"]}><RoleList /></ProtectedRoute>} />
            <Route path="/AddRole" element={<ProtectedRoute requiredRole={["developer"]}><AddRole /></ProtectedRoute>} />
            <Route path="/role/edit/:id" element={<ProtectedRoute requiredRole={["developer"]}><EditRole /></ProtectedRoute>} />

            {/* Department */}
            <Route path="/AddDepartment" element={<ProtectedRoute requiredRole={["developer","admin"]}><AddDepartment /></ProtectedRoute>} />
            <Route path="/ViewDepartment" element={<ProtectedRoute requiredRole={["developer","admin"]}><DepartmentList /></ProtectedRoute>} />
            <Route path="/department/edit/:id" element={<ProtectedRoute requiredRole={["developer","admin"]}><EditDepartment /></ProtectedRoute>} />

            {/* Employee Type */}
            <Route path="/AddEmployeetype" element={<ProtectedRoute requiredRole={["developer","admin"]}><AddEmployeetype /></ProtectedRoute>} />
            <Route path="/ViewEmployeetype" element={<ProtectedRoute requiredRole={["developer","admin"]}><EmployeetypeList /></ProtectedRoute>} />
            <Route path="/employeetype/edit/:id" element={<ProtectedRoute requiredRole={["developer","admin"]}><EditEmployeetype /></ProtectedRoute>} />

            {/* Employee */}
            <Route path="/employee" element={<ProtectedRoute requiredRole={["admin","HRM","developer"]}><EmployeeFormWizard /></ProtectedRoute>} />
            <Route path="/employeelist" element={<ProtectedRoute requiredRole={["admin","HRM","developer"]}><EmployeeList /></ProtectedRoute>} />

            {/* Bank */}
            <Route path="/AddBanktype" element={<ProtectedRoute requiredRole={["admin","developer"]}><AddBanktype /></ProtectedRoute>} />
            <Route path="/ViewBanktype" element={<ProtectedRoute requiredRole={["admin","developer"]}><BanktypeList /></ProtectedRoute>} />
            <Route path="/bank/edit/:id" element={<ProtectedRoute requiredRole={["admin","developer"]}><EditBanktype /></ProtectedRoute>} />

            {/* Company */}
            <Route path="/AddCompany" element={<ProtectedRoute requiredRole={["admin","developer"]}><AddCompany /></ProtectedRoute>} />
            <Route path="/ViewCompany" element={<ProtectedRoute requiredRole={["admin","developer"]}><CompanyList /></ProtectedRoute>} />
            <Route path="/company/edit/:id" element={<ProtectedRoute requiredRole={["admin","developer"]}><EditCompany /></ProtectedRoute>} />

            {/* Project */}
            <Route path="/AddProject" element={<ProtectedRoute requiredRole={["admin","developer"]}><AddProject /></ProtectedRoute>} />
            <Route path="/ViewProjects" element={<ProtectedRoute requiredRole={["admin","developer"]}><ProjectList /></ProtectedRoute>} />
            <Route path="/projects/edit/:id" element={<ProtectedRoute requiredRole={["admin","developer"]}><EditProject /></ProtectedRoute>} />

            {/* Registration Type */}
            <Route path="/AddRegistrationtype" element={<ProtectedRoute requiredRole={["admin","developer"]}><AddRegistrationtype /></ProtectedRoute>} />
            <Route path="/ViewRegistrationtype" element={<ProtectedRoute requiredRole={["admin","developer"]}><RegistrationtypeList /></ProtectedRoute>} />
            <Route path="/registrationtype/edit/:id" element={<ProtectedRoute requiredRole={["admin","developer"]}><EditRegistrationtype /></ProtectedRoute>} />

            {/* Country */}
            <Route path="/AddCountry" element={<ProtectedRoute requiredRole={["admin","developer"]}><AddCountry /></ProtectedRoute>} />
            <Route path="/Country" element={<ProtectedRoute requiredRole={["admin","developer"]}><CountriesList /></ProtectedRoute>} />
            <Route path="/Country/edit/:id" element={<ProtectedRoute requiredRole={["admin","developer"]}><EditCountry /></ProtectedRoute>} />

            {/* District */}
            <Route path="/District" element={<ProtectedRoute requiredRole={["admin","developer"]}><District /></ProtectedRoute>} />

            {/* Region */}
            <Route path="/regions" element={<ProtectedRoute requiredRole={["admin","developer"]}><RegionList /></ProtectedRoute>} />
            <Route path="/regions/add" element={<ProtectedRoute requiredRole={["admin","developer"]}><RegionForm /></ProtectedRoute>} />
            <Route path="/regions/edit/:id" element={<ProtectedRoute requiredRole={["admin","developer"]}><RegionForm /></ProtectedRoute>} />
            <Route path="/register" element={<ProtectedRoute requiredRole={["admin","developer"]}>  <Register />
            </ProtectedRoute>} />

            {/* Registration Fee */}
          
              <Route path="/AddRegistrationfee" element={<ProtectedRoute requiredRole={["admin","developer"]}><AddRegistrationfee /></ProtectedRoute>} />
            <Route path="/ViewRegistrationfee" element={<ProtectedRoute requiredRole={["admin","developer"]}><ViewRegistrationFee /></ProtectedRoute>} />
            <Route path="/registerfee/edit/:id" element={<ProtectedRoute requiredRole={["admin","developer"]}><EditRegistrationfee /></ProtectedRoute>} />

            {/* Members */}
            <Route path="/members" element={<ProtectedRoute requiredRole={["admin","approve"]}><Members /></ProtectedRoute>} />
            <Route path="/members/add" element={<ProtectedRoute requiredRole={["admin","approve","finance"]}><Members /></ProtectedRoute>} />
            <Route path="/members/edit/:id" element={<ProtectedRoute requiredRole={["admin","approve"]}><Members /></ProtectedRoute>} />
            <Route path="/members/view/:id" element={<ProtectedRoute requiredRole={["admin","approve"]}><Members /></ProtectedRoute>} />

            {/* Settings */}
            <Route path="/settings" element={<ProtectedRoute requiredRole={["developer"]}><Settings /></ProtectedRoute>} />

            {/* Users */}
            <Route path="/users/edit/:id" element={<ProtectedRoute requiredRole={["approve"]}><UpdateUser /></ProtectedRoute>} />

            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="/IDCARD" element={<ProtectedRoute requiredRole={["admin","HRM"]}><IDCardGenerator /></ProtectedRoute>} />
            <Route path="/Payments" element={<ProtectedRoute requiredRole={["admin","finance"]}><Payments /></ProtectedRoute>} />

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}

// App wrapper
function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
